import { render, staticRenderFns } from "./ChooseHisAddrBook.vue?vue&type=template&id=0097ac26&"
import script from "./ChooseHisAddrBook.vue?vue&type=script&lang=js&"
export * from "./ChooseHisAddrBook.vue?vue&type=script&lang=js&"
import style0 from "./ChooseHisAddrBook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports